import { useState } from "react";
import { Formik, Form as FormikForm } from "formik";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import FormDisplay from "./FormDisplay";
import pages from "../../../../constants/pages";
import { useAxios, useAlert } from "../../../../hooks";
import {
  checkRequiredFields,
  objectFromFormData,
  validationSchema,
} from "./campaignObject";

export default function Form({
  agents,
  formData,
  editState,
  setFormData,
  audiences,
  categories,
  setEditState,
  audienceSize,
  audienceData,
  connectionList,
  setAudienceData,
  preferredChannels,
  setAudienceCreated,
}) {
  const axios = useAxios();
  const { alert } = useAlert();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [agentToken, setAgentToken] = useState({});
  const { activeBrand } = useSelector((state) => state.memberDetails);

  const initialValues = {
    ...formData,
    originalStart_duration: formData.start_duration?.value,
    originalEnd_duration: formData.end_duration?.value,
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema}
      validateOnChange
      validateOnBlur={true}
      onSubmit={async (values, { setSubmitting }) => {
        if (checkRequiredFields(values).length > 0) {
          dispatch(
            alert({
              type: "error",
              message:
                "Some of the required fields are missing please fill them to proceed.",
            })
          );
          setSubmitting(false);
          return;
        }

        let url = "/user/create/campaign";
        let method = "POST";
        if (!!values.campaignID) {
          url = "/user/update/campaign/" + values.campaignID;
          method = "PUT";
        }

        let payload = objectFromFormData(values, activeBrand, initialValues);

        if (method === "PUT") {
          const startChanged =
            new Date(values.start_duration.value).getTime() !==
            new Date(values.originalStart_duration).getTime();
          const endChanged =
            new Date(values.end_duration.value).getTime() !==
            new Date(values.originalEnd_duration).getTime();

          const fields = payload.fields;

          const filteredFields = fields.filter((field) => {
            if (field.start_duration && !startChanged) return false;
            if (field.end_duration && !endChanged) return false;
            return true;
          });

          payload.fields = filteredFields;
        }

        try {
          const res = await axios({
            url,
            method,
            data: payload,
            disableRedirect: true,
          });

          if (res.status) {
            if (audienceData.ID !== values.audienceID) {
              const audienceRes = await axios({
                url: "/brand/getDetailsOfAudience/" + values.audienceID,
              });

              if (audienceRes.status) {
                let data = {};
                for await (let key of audienceRes.data.fields) {
                  data[Object.keys(key)[0]] = {
                    value: Object.values(key)[0],
                    mandatory: Object.values(key)[1],
                  };
                }

                data = {
                  ...data,
                  ID: audienceRes.data.audience_id,
                  brandID: audienceRes.data.brand_id,
                };

                await setAudienceData(data);
              }
            }

            if (!!values.campaignID) {
              setFormData((prev) => ({
                ...prev,
                displayStatus: res.data?.display_status,
                status: res.data?.status,
                campaignStatus: res.data?.campaignStatus,
              }));
              dispatch(
                alert({
                  message: "Campaign updated Successfully!",
                  type: "success",
                })
              );
              setEditState(false);
            } else {
              dispatch(
                alert({
                  message: "Campaign Created Successfully!",
                  type: "success",
                })
              );
              navigate(pages.campaignDetails.route + res.data.campaign_id);
            }
          }
        } catch (err) {
          console.error(err);
        } finally {
          setSubmitting(false);
        }
      }}
    >
      {(formikProps) => (
        <FormikForm>
          <FormDisplay
            agentToken={agentToken}
            setAgentToken={setAgentToken}
            agents={agents}
            audienceSize={audienceSize}
            audiences={audiences}
            editState={editState}
            categories={categories}
            formikProps={formikProps}
            audienceData={audienceData}
            setEditState={setEditState}
            connectionList={connectionList}
            setAudienceData={setAudienceData}
            preferredChannels={preferredChannels}
            setAudienceCreated={setAudienceCreated}
          />
        </FormikForm>
      )}
    </Formik>
  );
}
